import types from './types';

export const submitEditCompanyForm = () => ({
    type: types.SUBMIT_EDIT_COMPANY_FORM,
});

export const submitCreateCompanyForm = () => ({
    type: types.SUBMIT_CREATE_COMPANY_FORM,
});
